export default __webpack_public_path__ + "static/media/game.972f0636.svg";